<template>
  <quick-tips :tips="tips"/>
</template>

<script>
import QuickTips from '@/components/QuickTips.vue';

export default {
  components: {
    QuickTips,
  },
  data() {
    return {
      tips: [],
    };
  },
  created() {
    this.tips = [
      {
        header: 'File Searches',
        body: [
          `The File Search File Upload uses the same file format as the Match Options – 
          File Upload process. A File Search will return matched identifiers and near 
          matches but will not create new identifiers.`,
        ],
      },
      {
        header: 'Search Options',
        body: [
          `On the By File panel, the user will upload a file of student or staff records 
          and the system will search for a batch that matches the records. Use the ellipse 
          to drill into the search results. The user can refresh the search results if 
          needed or click Download or View Search Details. View Search Details takes the 
          user to the Batch Profile. The user can download the results.`, 
          `Note: When using Advanced upload type do not include the file format header and footer.`,
        ],
      },
      {
        header: 'Download Tab',
        body: [
          `On the Download tab, the user can choose the match status to download by using 
          the radio button. Download Options allows the user to choose Simple or Advanced 
          download format. The Advanced button allows the user to select the delimiter 
          type, the qualifier, the date format and whether to include the header and 
          footer.`,
        ],
      },
    ];
  },
};
</script>

<style lang="sass" scoped>
</style>
